import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../../Components/layouts";
import Typography from '@material-ui/core/Typography';
import GenericTable from '../../../Components/GenericTable';
import { CustomerServices } from '../../../Services/CustomerServices';
import { Pagination } from '@material-ui/lab';
import OutlinedButton from '../../../Components/OutlinedButton';
import { Paths } from '../../../Routes/routePaths';
import SearchBoxInput from '../../../Components/SearchBoxInput';
import { useHistory } from 'react-router';
import commonStyles from 'theme/commonStyles';

const customerServices = new CustomerServices();

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        background: '#FFFFFF',
        boxShadow: "0px 4px 30px rgba(12, 41, 84, 0.1)",
        borderRadius: 5,
        width: '100%',
        boxSizing: 'border-box',
        [theme.breakpoints.up('sm')]: {
            minHeight: 180,
        },
    },
    cardDetails: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: '100%',
        maxWidth: 174,
        height: 'auto',
        maxHeight: 132,
        paddingTop: 17,
        marginTop: 16,
        marginLeft: 0,
        borderRadius: 5,
        objectFit: 'contain',
        [theme.breakpoints.up('sm')]: {
            marginTop: 25,
            marginLeft: 20,
        },
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    cardTitle: {
        color: "#808080"
    },
    cardSubTitle: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        color: "#3D7DDD",
    },
    pageTitle: {
        marginBottom: theme.spacing(3),
        wordBreak: 'break-word',
    },
    searchBox: {
        border: "1px solid #808080",
        borderRadius: 25,
        padding: '7px 15px'
    },
    createCustomerBtn: {
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    }
}));

const columns = [
    { label: "Logo", key: 'logo' },
    { label: "Name", key: 'name' },
    { label: "Country", key: 'country' },
    { label: "Address", key: 'address' },
    { label: "Email", key: "email" },
    { label: "Contact", key: "contact_no" },
    { label: "Action", key: "action", actions: ["edit"] }
];

const Customers = () => {

    const classes = useStyles();
    const history = useHistory();
    const commonClasses = commonStyles();

    const [filterState, setFilterState] = React.useState({ page: 1, search: "" });
    const [administratorList, setAdministratorList] = React.useState([]);
    const [pagination, setPagination] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
        getAllCustomer({ page: 1, search: '' }); // Fetch data on initial load
    }, []);

    const getAllCustomer = async (queryData) => {
        const query = `search=${queryData.search}&page=${queryData.page}`;
        const customersList = await customerServices.getAllCustomer(`main/customerlist?${query}`);
        if (customersList && customersList.results) {
            setAdministratorList(customersList.results);
            setPagination(customersList.pagination);
        }
        setLoading(false);
    };

    const handlePageChange = (evt, page) => {
        setFilterState({ ...filterState, page });
        getAllCustomer({ ...filterState, page });
    };

    const handleSearch = (e) => {
        e.preventDefault();
        setLoading(true);
        setFilterState({ ...filterState, page: 1 });
        getAllCustomer({ ...filterState, page: 1 });
    };

    const handleItemClick = (row, action) => {
        if (!row) return null;
        history.push(`flowcustomer/${row.uuid}`);
    };

    const handleCreateNew = () => {
        history.push(Paths.createCustomer);
    };

    React.useEffect(() => {
        const getData = setTimeout(() => {
            getAllCustomer({ page: 1, search: filterState.search });
        }, 800);
        return () => clearTimeout(getData);
    }, [filterState.search]);

    const totalPages = pagination ? Math.ceil(pagination.total_pages) : 1;
    return (
        <Layout>
            <main>
                <div className={commonClasses.contentWrapper}>
                    <Typography variant="h4" className={classes.pageTitle}>Customers</Typography>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                        <Grid item xs={12} sm={6} md={4}>
                            <SearchBoxInput
                                value={filterState.search}
                                handleChange={(evt) => {
                                    setFilterState({ ...filterState, search: evt.target.value });
                                }}
                                handleSearch={handleSearch}
                            />
                        </Grid>
                        <Grid item xs={12} sm="auto">
                            <OutlinedButton
                                title={"Create Customer"}
                                handleClick={handleCreateNew}
                                align={'right'}
                                className={classes.createCustomerBtn}
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{ marginTop: 20 }}>
                        <GenericTable
                            columns={columns}
                            loading={loading}
                            handleItemClick={handleItemClick}
                            list={administratorList}
                        />
                    </Grid>
                    <Grid container style={{ marginTop: 22 }} >
                        {pagination && (
                            <Pagination
                                page={filterState.page}
                                onChange={handlePageChange}
                                style={{ margin: "0 auto" }}
                                count={totalPages}
                                variant="outlined"
                                shape="rounded"
                                siblingCount={2}
                                boundaryCount={2}
                            />
                        )}
                    </Grid>
                </div>
            </main>
        </Layout>
    );
}

export default Customers;
